import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const getAllPositionSchedulingRulesService = async (
  page: number = 1,
  status?: number,
  searchTerm: string = ''
) => {
  try {
    const queryStatus = status !== undefined ? `&status=${status}` : '';
    const querySearch = searchTerm ? `&q=${searchTerm}` : '';

    return await http.get<any>(
      `/v1/position-scheduling-rules?page=${page}&take=10${queryStatus}${querySearch}`
    );
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAllPositionSchedulingRulesService error: ', error);
  }
};

export const getPositionSchedulingRuleByIdService = async (id: string) => {
  try {
    return await http.get<any>(`/v1/position-scheduling-rules/${id}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getPositionSchedulingRuleByIdService error: ', error);
  }
};

export const createPositionSchedulingRuleService = async (data: any, setPercentage?: any) => {
  try {
    return await http.post<any>(`/v1/position-scheduling-rules`, data, setPercentage);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('createPositionSchedulingRuleService error: ', error);
  }
};

export const updatePositionSchedulingRuleService = async (id: string, data: any) => {
  try {
    return await http.put<any>(`/v1/position-scheduling-rules/${id}`, data);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('updatePositionSchedulingRuleService error: ', error);
  }
};

export const deletePositionSchedulingRuleService = async (id: string) => {
  try {
    return await http.delete<any>(`/v1/position-scheduling-rules/${id}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('deletePositionSchedulingRuleService error: ', error);
  }
};

export const restorePositionSchedulingRuleService = async (id: string) => {
  try {
    return await http.patch<any>(`/v1/position-scheduling-rules/${id}/restore`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('restorePositionSchedulingRuleService error: ', error);
  }
};
